import { render } from "./LiveTv.vue?vue&type=template&id=20c4bd60&scoped=true"
import script from "./LiveTv.vue?vue&type=script&lang=js"
export * from "./LiveTv.vue?vue&type=script&lang=js"

import "./LiveTv.vue?vue&type=style&index=0&id=20c4bd60&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c4bd60"]])

export default __exports__